<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-title class="d-flex justify-space-between align-center">
            <span>Otomatik Restart Ayarları</span>
            <div>
              <v-btn
                  color="info"
                  large
                  @click="autoSetup"
                  :loading="autoSetupLoading"
                  :disabled="autoSetupLoading || loading"
                  class="mr-4"
              >
                <v-icon left>mdi-auto-fix</v-icon>
                Otomatik Ayarla
              </v-btn>
              <v-btn
                  color="success"
                  large
                  @click="saveAll"
                  :loading="savingAll"
                  :disabled="savingAll"
              >
                <v-icon left>mdi-content-save-all</v-icon>
                Tüm Ayarları Kaydet
              </v-btn>
            </div>
          </v-card-title>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card elevation="4" class="auto-restart-card">


          <v-card-text>
            <v-alert
              v-if="alert.show"
              :type="alert.type"
              dismissible
              @input="alert.show = false"
            >
              {{ alert.message }}
            </v-alert>

            <v-data-table
              :headers="headers"
              :items="clients"
              :loading="loading"
              class="elevation-2 auto-restart-table"
              hide-default-footer
              disable-pagination
              :items-per-page="-1"
            >
              <!-- Header tooltips -->
              <template v-slot:header.saveTimeout>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" v-on="on">
                      Save Timeout (dk)
                      <v-icon small color="grey">mdi-information-outline</v-icon>
                    </span>
                  </template>
                  <span>Save mesajı gelmezse restart süresi (0 = devre dışı)</span>
                </v-tooltip>
              </template>

              <template v-slot:header.realtimeTimeout>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" v-on="on">
                      Realtime Timeout (dk)
                      <v-icon small color="grey">mdi-information-outline</v-icon>
                    </span>
                  </template>
                  <span>Realtime mesajı gelmezse restart süresi (0 = devre dışı)</span>
                </v-tooltip>
              </template>

              <template v-slot:header.historyTimeout>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" v-on="on">
                      History Timeout (dk)
                      <v-icon small color="grey">mdi-information-outline</v-icon>
                    </span>
                  </template>
                  <span>History mesajı gelmezse restart süresi (0 = devre dışı)</span>
                </v-tooltip>
              </template>

              <template v-slot:header.historyMultiTimeout>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" v-on="on">
                      History-Multi Timeout (dk)
                      <v-icon small color="grey">mdi-information-outline</v-icon>
                    </span>
                  </template>
                  <span>History-Multi mesajı gelmezse restart süresi (0 = devre dışı)</span>
                </v-tooltip>
              </template>

              <template v-slot:header.isActive>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" v-on="on">
                      Durum
                      <v-icon small color="grey">mdi-information-outline</v-icon>
                    </span>
                  </template>
                  <span>Otomatik restart aktif/pasif durumu</span>
                </v-tooltip>
              </template>

              <template v-slot:item.clientInfo="{ item }">
                <div>
                  <div class="font-weight-bold">{{ item.mqttClient }}</div>
                  <div class="text-caption text-grey">{{ item.manufacturer }} {{ item.model }}</div>
                  <div class="text-caption text-grey">{{ item.dataloggerName }}</div>
                </div>
              </template>

              <template v-slot:item.saveTimeout="{ item }">
                <v-text-field
                  v-model.number="item.autoRestart.save_timeout"
                  type="number"
                  min="0"
                  dense
                  hide-details
                  outlined
                  style="min-width: 120px;"
                  :class="{ 'auto-setup-field': autoSetupFields.has(`${item.id}-save_timeout`) }"
                ></v-text-field>
              </template>

              <template v-slot:item.realtimeTimeout="{ item }">
                <v-text-field
                  v-model.number="item.autoRestart.realtime_timeout"
                  type="number"
                  min="0"
                  dense
                  hide-details
                  outlined
                  style="min-width: 120px;"
                  :class="{ 'auto-setup-field': autoSetupFields.has(`${item.id}-realtime_timeout`) }"
                ></v-text-field>
              </template>

              <template v-slot:item.historyTimeout="{ item }">
                <v-text-field
                  v-model.number="item.autoRestart.history_timeout"
                  type="number"
                  min="0"
                  dense
                  hide-details
                  outlined
                  style="min-width: 120px;"
                  :class="{ 'auto-setup-field': autoSetupFields.has(`${item.id}-history_timeout`) }"
                ></v-text-field>
              </template>

              <template v-slot:item.historyMultiTimeout="{ item }">
                <v-text-field
                  v-model.number="item.autoRestart.history_multi_timeout"
                  type="number"
                  min="0"
                  dense
                  hide-details
                  outlined
                  style="min-width: 120px;"
                  :class="{ 'auto-setup-field': autoSetupFields.has(`${item.id}-history_multi_timeout`) }"
                ></v-text-field>
              </template>

                            <template v-slot:item.isActive="{ item }">
                <v-switch
                  v-model="item.autoRestart.is_active"
                  @change="toggleAutoRestart(item)"
                  :loading="item.toggling"
                  color="success"
                  :label="item.autoRestart.is_active ? 'Aktif' : 'Pasif'"
                  hide-details
                ></v-switch>
              </template>

              <template v-slot:item.actions="{ item }">
                <v-btn
                  color="primary"
                  small
                  @click="saveRow(item)"
                  :loading="item.saving"
                  :disabled="item.saving"
                >
                  <v-icon small left>mdi-content-save</v-icon>
                  Kaydet
                </v-btn>
              </template>
            </v-data-table>

            <v-row class="mt-4">
              <v-col cols="12" class="text-center">

              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'AutoRestart',
  data() {
    return {
      clients: [],
      loading: false,
      savingAll: false,
      autoSetupLoading: false,
      autoSetupFields: new Set(),
      alert: {
        show: false,
        type: 'success',
        message: ''
      },
      headers: [
        { text: 'Client Bilgileri', value: 'clientInfo', sortable: false, width: '250px', align: 'start' },
        {
          text: 'Save Timeout (dk)',
          value: 'saveTimeout',
          sortable: false,
          width: '160px',
          align: 'center'
        },
        {
          text: 'Realtime Timeout (dk)',
          value: 'realtimeTimeout',
          sortable: false,
          width: '160px',
          align: 'center'
        },
        {
          text: 'History Timeout (dk)',
          value: 'historyTimeout',
          sortable: false,
          width: '160px',
          align: 'center'
        },
        {
          text: 'History-Multi Timeout (dk)',
          value: 'historyMultiTimeout',
          sortable: false,
          width: '180px',
          align: 'center'
        },
        {
          text: 'Durum',
          value: 'isActive',
          sortable: false,
          width: '120px',
          align: 'center'
        },
        { text: 'İşlemler', value: 'actions', sortable: false, width: '140px', align: 'center' }
      ]
    }
  },
  async created() {
    await this.fetchClients()
  },
  methods: {
    async fetchClients() {
      this.loading = true
      try {
        // Status verilerini ve auto restart ayarlarını paralel olarak çek
        const [statusResponse, autoRestartResponse] = await Promise.all([
          this.$api.get('/api/status'),
          this.$api.get('/api/servers/auto-restart')
        ])

        const statusData = statusResponse.data
        const autoRestartData = autoRestartResponse.data

        // Auto restart verilerini client ID'ye göre indexle
        const autoRestartMap = new Map()
        autoRestartData.forEach(autoRestart => {
          autoRestartMap.set(autoRestart.client_id, {
            save_timeout: autoRestart.save_timeout,
            realtime_timeout: autoRestart.realtime_timeout,
            history_timeout: autoRestart.history_timeout,
            history_multi_timeout: autoRestart.history_multi_timeout,
            is_active: autoRestart.is_active
          })
        })

        // Tüm client'ları topla ve auto restart ayarlarını birleştir
        const allClients = []

        statusData.forEach(datalogger => {
          datalogger.clients.forEach(client => {
            const autoRestartSettings = autoRestartMap.get(client.id) || {
              save_timeout: 0,
              realtime_timeout: 0,
              history_timeout: 0,
              history_multi_timeout: 0,
              is_active: false
            }

            allClients.push({
              ...client,
              dataloggerName: datalogger.name,
              dataloggerId: datalogger.id,
              autoRestart: autoRestartSettings,
              saving: false,
              toggling: false
            })
          })
        })

        this.clients = allClients
      } catch (error) {
        console.error('Error fetching clients:', error)
        this.showAlert('error', 'Client bilgileri yüklenirken hata oluştu')
      } finally {
        this.loading = false
      }
    },

    async saveRow(item) {
      item.saving = true
      try {
        const updateData = {
          save_timeout: item.autoRestart.save_timeout,
          realtime_timeout: item.autoRestart.realtime_timeout,
          history_timeout: item.autoRestart.history_timeout,
          history_multi_timeout: item.autoRestart.history_multi_timeout,
          is_active: item.autoRestart.is_active
        }

        await this.$api.put(`/api/servers/client/${item.id}/auto-restart`, updateData)
        console.log('Save Row - Client Data:', {
          mqttClient: item.mqttClient,
          dataloggerName: item.dataloggerName,
          id: item.id
        })
        this.showAlert('success', `${item.dataloggerName || item.mqttClient || 'Bilinmeyen Client'} için ayarlar kaydedildi`)
      } catch (error) {
        console.error('Error saving auto restart setting:', error)
        this.showAlert('error', `${item.dataloggerName || item.mqttClient || 'Bilinmeyen Client'} için ayarlar kaydedilemedi`)
      } finally {
        item.saving = false
      }
    },

    async saveAll() {
      this.savingAll = true
      try {
        const settingsData = this.clients.map(client => ({
          clientId: client.id,
          save_timeout: client.autoRestart.save_timeout,
          realtime_timeout: client.autoRestart.realtime_timeout,
          history_timeout: client.autoRestart.history_timeout,
          history_multi_timeout: client.autoRestart.history_multi_timeout,
          is_active: client.autoRestart.is_active
        }))

        await this.$api.put('/api/servers/auto-restart', settingsData)
        this.showAlert('success', 'Tüm otomatik restart ayarları başarıyla kaydedildi')
      } catch (error) {
        console.error('Error saving all auto restart settings:', error)
        this.showAlert('error', 'Ayarlar kaydedilirken hata oluştu')
      } finally {
        this.savingAll = false
      }
    },

    async toggleAutoRestart(item) {
      item.toggling = true
      try {
        const itemCopy = JSON.parse(JSON.stringify(item))

        const updateData = {
          save_timeout: itemCopy.autoRestart.save_timeout,
          realtime_timeout: itemCopy.autoRestart.realtime_timeout,
          history_timeout: itemCopy.autoRestart.history_timeout,
          history_multi_timeout: itemCopy.autoRestart.history_multi_timeout,
          is_active: itemCopy.autoRestart.is_active
        }

        await this.$api.put(`/api/servers/client/${itemCopy.id}/auto-restart`, updateData)

        const statusText = item.autoRestart.is_active ? 'aktif edildi' : 'deaktif edildi'
        console.log('Toggle AutoRestart - Client Data:', {
          mqttClient: item.mqttClient,
          dataloggerName: item.dataloggerName,
          id: item.id
        })
        this.showAlert('success', `${item.dataloggerName || item.mqttClient || 'Bilinmeyen Client'} için otomatik restart ${statusText}`)
      } catch (error) {
        console.error('Error toggling auto restart:', error)
        // Revert the toggle on error
        item.autoRestart.is_active = !item.autoRestart.is_active
        this.showAlert('error', `${item.dataloggerName || item.mqttClient || 'Bilinmeyen Client'} için durum değiştirilemedi`)
      } finally {
        item.toggling = false
      }
    },

    async autoSetup() {
      this.autoSetupLoading = true
      this.autoSetupFields.clear()

      try {
        // /status endpoint'inden veri çek
        const response = await this.$api.get('/api/status')
        const statusData = response.data

        // Her client için ayarları güncelle
        this.clients.forEach(client => {
          // Client'ın bulunduğu datalogger'ı bul
          const datalogger = statusData.find(d => d.id === client.dataloggerId)
          if (!datalogger) return

          // Client'ın son mesaj durumlarını bul
          const clientStatus = datalogger.clients.find(c => c.id === client.id)
          if (!clientStatus) return

          // Her mesaj tipi için timeout ayarla
          this.processClientMessageType(client, clientStatus, 'save', 'save_timeout')
          this.processClientMessageType(client, clientStatus, 'realtime', 'realtime_timeout')
          this.processClientMessageType(client, clientStatus, 'history', 'history_timeout')
          this.processClientMessageType(client, clientStatus, 'history-multi', 'history_multi_timeout')
        })

        this.showAlert('success', `Otomatik ayarlama tamamlandı. ${this.autoSetupFields.size} alan güncellendi.`)

      } catch (error) {
        console.error('Error during auto setup:', error)
        this.showAlert('error', 'Otomatik ayarlama sırasında hata oluştu')
      } finally {
        this.autoSetupLoading = false
      }
    },

    processClientMessageType(client, clientStatus, messageType, timeoutField) {
      let lastSeen = null

      // Group mesajlarından en son mesajı bul
      if (clientStatus.groupMessages &&
          clientStatus.groupMessages.messageType === messageType) {
        lastSeen = new Date(clientStatus.groupMessages.lastSeen)
      }

      // History mesajlarından en son mesajı bul
      if (clientStatus.historyMessages &&
          clientStatus.historyMessages.messageType === messageType) {
        const historyTime = new Date(clientStatus.historyMessages.lastSeen)
        if (!lastSeen || historyTime > lastSeen) {
          lastSeen = historyTime
        }
      }

      let newValue = 0

      if (lastSeen) {
        const now = new Date()
        const diffMinutes = Math.floor((now - lastSeen) / (1000 * 60))

        if (diffMinutes <= 15) {
          newValue = 15
        } else if (diffMinutes <= 60) {
          newValue = 60
        } else if (diffMinutes <= 180) {
          newValue = 180
        } else {
          newValue = 0
        }
      }

      // Sadece değer değiştiyse vurgula
      const oldValue = client.autoRestart[timeoutField]
      if (oldValue !== newValue) {
        client.autoRestart[timeoutField] = newValue
        this.autoSetupFields.add(`${client.id}-${timeoutField}`)
      }
    },

    showAlert(type, message) {
      this.alert = {
        show: true,
        type: type,
        message: message
      }
    }
  }
}
</script>

<style scoped>
.v-data-table :deep(.v-data-table__wrapper) {
  overflow-x: auto;
}

/* Light Theme Styles */
.v-theme--light .v-data-table :deep(th) {
  white-space: nowrap;
  font-weight: 600 !important;
  background-color: #f5f7fa;
  color: #2C5F7C;
  border-bottom: 2px solid #A8D5BA;
}

.v-theme--light .v-data-table :deep(tbody tr:hover) {
  background-color: rgba(168, 213, 186, 0.1) !important;
}



/* Dark Theme Styles */
.v-theme--dark .v-data-table :deep(th) {
  white-space: nowrap;
  font-weight: 600 !important;
  background-color: #2D2D2D;
  color: #A8D5BA;
  border-bottom: 2px solid #4A8DB8;
}

.v-theme--dark .v-data-table :deep(tbody tr) {
  background-color: #1A1A1A;
}

.v-theme--dark .v-data-table :deep(tbody tr:hover) {
  background-color: rgba(168, 213, 186, 0.15) !important;
}

.v-theme--dark .v-card {
  background-color: #2D2D2D !important;
}



.v-theme--dark .v-text-field--outlined :deep(.v-field__outline) {
  --v-field-border-color: #4A8DB8;
}

.v-theme--dark .v-text-field--outlined:hover :deep(.v-field__outline) {
  --v-field-border-color: #A8D5BA;
}

.v-theme--dark .v-text-field--outlined.v-field--focused :deep(.v-field__outline) {
  --v-field-border-color: #A8D5BA;
}

.v-theme--dark .v-text-field :deep(input) {
  color: #A8D5BA;
}

/* Common Styles */
.v-data-table :deep(td) {
  padding: 12px 8px !important;
}

.v-text-field :deep(.v-input__control) {
  min-height: 40px;
}

.v-text-field :deep(input) {
  text-align: center;
  font-weight: 500;
  font-size: 14px;
}

.v-text-field.v-text-field--outlined :deep(.v-input__control .v-input__slot) {
  min-height: 40px;
}

.v-card-title .v-icon {
  color: white !important;
}

.v-data-table :deep(th span) {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
}

.v-alert ul {
  margin-left: 20px;
}

.v-alert li {
  margin-bottom: 2px;
}

/* Button Styles for Dark Theme */
.v-theme--dark .v-btn--variant-elevated {
  background-color: #4A8DB8;
  color: white;
}

.v-theme--dark .v-btn--variant-elevated:hover {
  background-color: #A8D5BA;
  color: #1A1A1A;
}

.v-theme--dark .v-btn.v-btn--variant-elevated.v-btn--color-success {
  background-color: #58D68D;
  color: #1A1A1A;
}

.v-theme--dark .v-btn.v-btn--variant-elevated.v-btn--color-success:hover {
  background-color: #A8D5BA;
}

/* Tooltip Styles for Dark Theme */
.v-theme--dark .v-tooltip .v-overlay__content {
  background-color: #2D2D2D;
  color: #A8D5BA;
  border: 1px solid #4A8DB8;
}

/* Data Table Header Icons */
.v-theme--dark .v-data-table :deep(th .v-icon) {
  color: #A8D5BA !important;
}

.v-theme--light .v-data-table :deep(th .v-icon) {
  color: #2C5F7C !important;
}

/* Switch Styles */
.v-theme--dark .v-switch :deep(.v-selection-control__wrapper) {
  color: #A8D5BA;
}

.v-theme--dark .v-switch :deep(.v-switch__track) {
  background-color: #4A4A4A;
  transition: background-color 0.3s ease;
}

.v-theme--dark .v-switch.v-input--is-active :deep(.v-switch__track) {
  background-color: #58D68D;
}

.v-theme--dark .v-switch :deep(.v-switch__thumb) {
  background-color: #A8D5BA;
  transition: background-color 0.3s ease;
}

.v-theme--dark .v-switch.v-input--is-active :deep(.v-switch__thumb) {
  background-color: white;
}

.v-theme--dark .v-switch.v-input--is-disabled :deep(.v-switch__track) {
  background-color: #333333 !important;
  opacity: 0.6;
}

.v-theme--dark .v-switch.v-input--is-disabled :deep(.v-switch__thumb) {
  background-color: #666666 !important;
}

.v-theme--dark .v-label {
  color: #A8D5BA !important;
  font-weight: 500;
  transition: color 0.3s ease;
}

.v-theme--dark .v-switch.v-input--is-disabled .v-label {
  color: #666666 !important;
}

.v-theme--light .v-switch :deep(.v-switch__track) {
  transition: background-color 0.3s ease;
}

.v-theme--light .v-switch.v-input--is-active :deep(.v-switch__track) {
  background-color: #58D68D;
}

.v-theme--light .v-switch.v-input--is-active :deep(.v-switch__thumb) {
  background-color: white;
}

.v-theme--light .v-switch.v-input--is-disabled :deep(.v-switch__track) {
  opacity: 0.6;
}

.v-theme--light .v-switch.v-input--is-disabled :deep(.v-switch__thumb) {
  opacity: 0.6;
}

.v-theme--light .v-label {
  font-weight: 500;
  transition: color 0.3s ease;
}

.v-theme--light .v-switch.v-input--is-disabled .v-label {
  color: #999999 !important;
}

/* Switch Loading Animation */
.v-switch.v-input--is-loading :deep(.v-switch__thumb) {
  animation: pulse 1.5s infinite;
}

@keyframes pulse {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
  100% {
    opacity: 1;
  }
}

/* Alert Styles for Dark Theme */
.v-theme--dark .v-alert {
  background-color: #2D2D2D;
  border: 1px solid #4A8DB8;
}

.v-theme--dark .v-alert.v-alert--type-success {
  background-color: rgba(88, 214, 141, 0.1);
  border-color: #58D68D;
  color: #A8D5BA;
}

.v-theme--dark .v-alert.v-alert--type-error {
  background-color: rgba(231, 76, 60, 0.1);
  border-color: #E74C3C;
  color: #ff9999;
}

/* Card Styles */
.auto-restart-card {
  border-radius: 12px;
  overflow: hidden;
}

.auto-restart-header {
  padding: 20px 24px;
  font-weight: 600;
}

.auto-restart-table {
  border-radius: 8px;
  overflow: hidden;
}

/* Loading Overlay for Dark Theme */
.v-theme--dark .v-data-table :deep(.v-data-table__loading) {
  background-color: rgba(26, 26, 26, 0.8);
}

.v-theme--dark .v-data-table :deep(.v-data-table__loading .v-progress-circular) {
  color: #A8D5BA;
}

/* Scrollbar Styles for Dark Theme */
.v-theme--dark .v-data-table :deep(.v-data-table__wrapper)::-webkit-scrollbar {
  height: 8px;
}

.v-theme--dark .v-data-table :deep(.v-data-table__wrapper)::-webkit-scrollbar-track {
  background: #2D2D2D;
}

.v-theme--dark .v-data-table :deep(.v-data-table__wrapper)::-webkit-scrollbar-thumb {
  background: #4A8DB8;
  border-radius: 4px;
}

.v-theme--dark .v-data-table :deep(.v-data-table__wrapper)::-webkit-scrollbar-thumb:hover {
  background: #A8D5BA;
}

/* Auto Setup Field Highlighting */
.auto-setup-field :deep(.v-field__outline) {
  --v-field-border-color: #4CAF50 !important;
  --v-field-border-width: 2px !important;
}

.v-theme--dark .auto-setup-field :deep(.v-field__outline) {
  --v-field-border-color: #66BB6A !important;
  --v-field-border-width: 2px !important;
}

.auto-setup-field :deep(.v-field__input) {
  background-color: rgba(76, 175, 80, 0.05) !important;
}

.v-theme--dark .auto-setup-field :deep(.v-field__input) {
  background-color: rgba(102, 187, 106, 0.1) !important;
}
</style>
